
import React from 'react';
import { useHovercardStore, HovercardAnchor, Hovercard } from '@ariakit/react';

interface HeaderWithTooltipProps {
  children: React.ReactNode;
  headerText: string;
  className?: string;
}

export default function HeaderWithTooltip({
  children,
  headerText,
  className = ''
}: HeaderWithTooltipProps) {
  const hovercard = useHovercardStore({
    showTimeout: 500,
    hideTimeout: 0,
    placement: 'top'
  });

  return (
    <>
      <HovercardAnchor
        store={hovercard}
        className={`block ${className}`}
      >
        {children}
      </HovercardAnchor>

      <Hovercard
        store={hovercard}
        gutter={8}
        className="z-[9999] max-w-xs rounded-md border border-gray-200 bg-white px-3 py-2 shadow-lg"
      >
        <div className="text-sm text-gray-900">
          {headerText}
        </div>
      </Hovercard>
    </>
  );
}
